import { refreshToken } from '../../hooks/useTokenVerifier';

export const requestCheckTokenInterceptor = (host) => client => async action => {
  const savedAuth = localStorage.getItem('auth');

  if (savedAuth) {
    const auth = JSON.parse(savedAuth);
    
    const expiresAt = auth?.expiresAt;
    const remainingTime = (expiresAt - Date.now());
    const oneMinuteInMilliseconds = 60000;
    const limit = 10 * oneMinuteInMilliseconds;
    const shouldRefresh = remainingTime < limit;
    // console.log({expiresAt, remainingTime, limit, shouldRefresh})
    if (shouldRefresh) {
      await refreshToken(host, auth)
    } 
  }

  return action;
};

export const axiosRequestCheckTokenInterceptor = (host) => async action => {
  const savedAuth = localStorage.getItem('auth');

  if (savedAuth) {
    const auth = JSON.parse(savedAuth);
    
    const expiresAt = auth?.expiresAt;
    const remainingTime = (expiresAt - Date.now());
    const oneMinuteInMilliseconds = 60000;
    const limit = 10 * oneMinuteInMilliseconds;
    const shouldRefresh = remainingTime < limit;
    // console.log({expiresAt, remainingTime, limit, shouldRefresh})
    if (shouldRefresh) {
      await refreshToken(host, auth)
    } 
  }

  return action;
};